exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._24Q2 {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background-color: #fff;\n    opacity: 0;\n    pointer-events: none;\n    transform: translate3d(0, 100%, 0);\n    transition: 0.3s ease transform;\n}\n\n._3_xA {\n    position: absolute;\n    margin: 0 !important;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    opacity: 0;\n    pointer-events: none;\n    transition: 0.15s ease opacity;\n}\n\n._24Q2.XBL- {\n    transform: none;\n}\n\n._24Q2.XBL-, ._3_xA.XBL- {\n    opacity: 1;\n    pointer-events: all;\n}\n\n._3KQh {\n    position: absolute;\n    top: 0.5em;\n    right: 0.5em;\n    z-index: 1;\n}\n", ""]);

// exports
exports.locals = {
	"modal": "_24Q2",
	"backdrop": "_3_xA",
	"open": "XBL-",
	"closeBtn": "_3KQh"
};